import { useAppDispatch } from "../../hooks";
import { logout as logoutAction } from "./slice";
import LocalStorage from "../../../util/storage";

export const useLogout = () => {
	const dispatch = useAppDispatch();

	return {
		logout: () => {
			LocalStorage.remove("authData");
			dispatch(logoutAction());
		}
	};
};
